/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as MemberDataStoreActions from './member-data-store.actions';

import { Member } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'MemberDataStore';

import * as lodash from 'lodash';

/* State interface */
export interface MemberState {
  isLoading?: boolean;
  members?: Member[];
  activeMember?: Member;
  actionLogs?: any[] | null | undefined;
}

/* Initial values */
export const initialState: MemberState = {
  isLoading: null,
  members: null,
  activeMember: null,
  actionLogs: null,
};

export const reducer = createReducer(
  initialState,
  on(MemberDataStoreActions.GetMembers, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(MemberDataStoreActions.GetMembersSuccessful, (state, action) => ({
    ...state,
    members: action.payload.members,
    isLoading: false,
  })),

  on(MemberDataStoreActions.GetMembersFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(MemberDataStoreActions.GetMemberById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(MemberDataStoreActions.GetMemberByIdSuccessful, (state, action) => ({
    ...state,
    /* TODO: replace item by id from data array */
    isLoading: false,
  })),

  on(MemberDataStoreActions.GetMemberByIdFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(MemberDataStoreActions.GetActionLogsSuccessful, (state, action) => ({
    ...state,
    actionLogs: lodash.orderBy(action.payload.actionLogs, ['createdDate'], ['desc']),
    isLoading: false,
  })),

  on(
    MemberDataStoreActions.GetActiveMemberWithRelationsById,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    MemberDataStoreActions.GetActiveMemberByIdWithRelationsSuccessful,
    (state, action) => ({
      ...state,
      activeMember: action.payload.activeMember,
      isLoading: false,
    }),
  ),

  on(
    MemberDataStoreActions.GetActiveMemberByIdWithRelationsFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(MemberDataStoreActions.CreateMember, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(MemberDataStoreActions.CreateMemberSuccessful, (state, action) => ({
    ...state,
    members: [...(state.members ?? []), action.payload.member],
    isLoading: false,
  })),

  on(MemberDataStoreActions.CreateMemberFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(MemberDataStoreActions.UpdateMember, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(MemberDataStoreActions.UpdateMemberSuccessful, (state, action) => ({
    ...state,
    members: updateEntityInArray<Member>(
      action.payload.id,
      action.payload.data,
      state.members ?? [],
    ),
    isLoading: false,
  })),

  on(MemberDataStoreActions.UpdateMemberFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(MemberDataStoreActions.DeleteMember, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(MemberDataStoreActions.DeleteMemberSuccessful, (state, action) => ({
    ...state,
    members:
      state.members?.filter((item) => action.payload.id !== item.id) ?? [],
    isLoading: false,
  })),

  on(MemberDataStoreActions.DeleteMemberFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(MemberDataStoreActions.ResetState, () => initialState),
);
